import {redirect} from 'react-router-dom';
import {sendChatMessage} from '../store/slices/chat_slice';
import {store as AppStore} from '../store/store';
import {parseIntOrFallback} from '../support/parse_int';

export async function postMessageAction(store: typeof AppStore, request: Request) {
    if (request.method !== 'POST') {
        throw new Response('', {status: 405});
    }

    const token = store.getState().exchangeToken.token;
    if (token) {
        const formData = await request.formData();
        const message = formData.get('message')?.toString();
        const notificationId = parseIntOrFallback(formData.get('notification_id')?.toString(), undefined);
        const file = formData.get('file');
        if (message) {
            await store.dispatch(
                sendChatMessage({token, message, persistedNotificationId: notificationId, file: file}),
            );
            return redirect('/chat');
        }
        throw new Response('', {status: 500});
    }
}
